import { useNWAElementImpression } from '@ria-client/segment/hooks/useNWAElementImpression';
import { useNWAElementInteracted } from '@ria-client/segment/hooks/useNWAElementInteracted';

/** Element Viewed on scroll-in, Element Interacted (paired by impressionId) on `track`. */
export function useTrackedElement(component: string, destinationUrl?: string) {
  const { ensureViewed, impressionId, ref } = useNWAElementImpression({
    component,
    destinationUrl,
  });
  const { trackElementInteracted } = useNWAElementInteracted();

  function track(interactionType?: string) {
    ensureViewed();
    void trackElementInteracted({ component, impressionId, interactionType });
  }

  return { ref, track };
}
